<i18n>
{
  "en": {
    "label": {
      "mail": "email",
      "password": "password",
      "passwordConfirm": "password (confirm)",
      "submitBtn": "Login"
    },
    "passwordForget": {
      "intro": "If you reset password, please click ",
      "here": "here"
    },
    "invalidEmailOrPassword": "Invalid email or password"
  },
  "ja": {
    "label": {
      "mail": "メールアドレス",
      "password": "パスワード",
      "passwordConfirm": "確認用パスワード",
      "submitBtn": "ログイン"
    },
    "passwordForget": {
      "intro": "パスワードを忘れた方は",
      "here": "こちら"
    },
    "invalidEmailOrPassword": "Emailもしくはパスワードが違います"
  }
}
</i18n>

<template>
  <div>
    <v-form>
      <TextInput
        name="email"
        v-model="email"
        :placeholderValue="this.$t('label.mail')"
        v-validate="'required|email'"
        :readonly="inProgress"
      />

      <TextInput
        v-model="password"
        :placeholderValue="this.$t('label.password')"
        type="password"
        name="password"
        v-validate.disable="{ required: true, min: 8, password }"
        :readonly="inProgress"
      ></TextInput>

      <SubmitBtn
        :colorCode="submitBtn.colorCode"
        @click="login"
        :autoSpread="true"
      >
        <strong>{{ $t('label.submitBtn') }}</strong>
      </SubmitBtn>
    </v-form>

    <span v-for="(error, key, index) in errors.all()" :key="index">
      <p class="vee-error" style="color: #F87060">{{ error }}</p>
    </span>

    <v-progress-linear
      v-show="inProgress"
      :indeterminate="inProgress"
    ></v-progress-linear>

    <v-alert type="error" outline :value="errorMessage">{{
      errorMessage
    }}</v-alert>
  </div>
</template>

<script>
import SubmitBtn from '@/components/atoms/SubmitBtn.vue';
import TextInput from '@/components/atoms/TextInput.vue';

export default {
  components: {
    SubmitBtn,
    TextInput
  },
  props: {
    onSubmit: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      inProgress: false,
      submitBtn: {
        colorCode: 'primary'
      },
      show1: false,
      email: '',
      password: '',
      passwordConfirm: '',
      errorMessage: '',
      isBtnDFlex: this.$vuetify.breakpoint.smAndDown
    };
  },
  methods: {
    login() {
      this.$validator.validate().then(result => {
        if (result !== true) return;

        this.errorMessage = false;
        this.inProgress = true;

        this.$nextTick(function() {
          this.onSubmit({
            email: this.email,
            password: this.password
          }).catch(() => {
            this.errorMessage = this.$t('invalidEmailOrPassword');
            this.hasError = true;
            this.inProgress = false;
          });
        });
      });
    }
  }
};
</script>
